export const normalizeEquipmentId = (value: unknown): number | null => {
  if (value == null || value === '') return null;
  const parsed = Number(value);
  return Number.isNaN(parsed) ? null : parsed;
};

export const hasEquipmentSwitch = (currentValue: unknown, nextValue: unknown): boolean => {
  const currentEquipmentId = normalizeEquipmentId(currentValue);
  const nextEquipmentId = normalizeEquipmentId(nextValue);
  return (
    currentEquipmentId != null && nextEquipmentId != null && currentEquipmentId !== nextEquipmentId
  );
};

export const getApiErrorMessage = (error: any, fallback: string): string => {
  const data = error?.response?.data;
  if (!data) return fallback;
  if (typeof data === 'string') return data;
  if (typeof data?.detail === 'string') return data.detail;
  if (Array.isArray(data?.code) && data.code.length) return String(data.code[0]);
  if (Array.isArray(data?.equipment) && data.equipment.length) return String(data.equipment[0]);
  const firstKey = Object.keys(data)[0];
  if (firstKey && Array.isArray(data[firstKey]) && data[firstKey].length) {
    return String(data[firstKey][0]);
  }
  return fallback;
};
